import React, { useEffect, useState } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import cn from 'classnames';
import style from './giftCardEntry.module.css';
import { APP_CONFIG } from '@constants';
import { flowType } from '@utility/userInfo';
import { LABEL } from '../../veriables';
import { urlSearchParams } from '../../utility/utills';
import { TouchableButton } from '@components/common/Touchable';
import ModalHeader from '../../components/common/ModalHeader/index';
import ServerInstructions from './ServerInstructions';
import {ReactComponent as GiftCardExclamation } from '@assets/images/giftCardExclamation.svg';


const GiftCardactivation = props => {
  // Props Destructuring

  const {
    OnProcess,
    tab,
    sendAndPay,
    loading,
    getActivateGiftCards,
    serverAppTheme,
    setOrderData,
    balanceEnabled,
    setIsFromCheckList,
    checkListHashTable,
    setSeat,
    seat,
    orderingPortraitOrientation
  } = props;

  // State Management

  const [cards, setCards] = useState([]);
  let disPlayBtn = urlSearchParams('type') == 'more' ? false : true;

  // React Hooks

  useEffect(() => {
    if (props?.seat?.cards?.length > 0) {
      let data = props?.seat?.cards;
      setCards(data ? data : []);
    }
  }, [tab]);

  // Methods


  const getNames = i => {
    let items = i;
    let names = { name: '', modifiers: [] };
    let data = JSON.parse(items.orderJson);
    names.name =
      props.menuItemsHashTable[JSON.parse(items.orderJson).menuItemId].name;
    if (data.modifiers?.length > 0) {
      const modifiersBasedOnLinkedItem =
        JSON.parse(items.orderJson).modifierJson &&
        JSON.parse(JSON.parse(items.orderJson).modifierJson).hasLinkedMenuItem
          ? JSON.parse(JSON.parse(items.orderJson).modifierJson).modifiers
          : JSON.parse(items.orderJson).modifiers;
      let a = [];
      modifiersBasedOnLinkedItem.forEach(i => {
        a.push(i.modifierName);
      });
      names.modifiers = a;
    }
    return names;
  };

  const handlebacKToCheckListing = () => {
    if (seat && seat.id && checkListHashTable && checkListHashTable[seat.id]) {
      const updatedCheckData = checkListHashTable[seat.id];
      setSeat(updatedCheckData);
      window.sessionStorage.setItem('seat', JSON.stringify(updatedCheckData));
    }

      props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
        replace: true,
      });
    // }
    // else {
    //   props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
    // }
    setIsFromCheckList(false);
  };

  const getSwipeBtnDisable = () => {
    return (
      props.auth?.loyaltyInfo?.giftCardSaleMethods === null ||
      props.auth?.loyaltyInfo?.giftCardSaleMethods.length == 0 ||
      (props.auth?.loyaltyInfo?.giftCardSaleMethods.length > 0 &&
        props.auth?.loyaltyInfo?.giftCardSaleMethods.includes(''))
    );
  };

  const getBalanceBtnDisable = () => {
    return (
      props.auth?.loyaltyInfo?.giftCardMethods === null ||
      props.auth?.loyaltyInfo?.giftCardMethods.length == 0 ||
      (props.auth?.loyaltyInfo?.giftCardMethods.length > 0 &&
        props.auth?.loyaltyInfo?.giftCardMethods.includes(''))
    );
  };

  // HTML CSS Code

  return (
    <div
      style={{
        backgroundColor: serverAppTheme.popUp_bg,
        border: serverAppTheme?.popupBorder,
        boxShadow: serverAppTheme?.popUp_box_shadow,
        color: serverAppTheme?.primary_text,
      }}
      className={cn('col-12 col-md-12 p-0 mx-0 h-100')}
    >
      {loading && <Loader />}
      <ModalHeader
        isTab={props.seat?.tab}
        stationName={props.seat?.stationName}
        tileHeader="Gift Card"
        seatNumber={props.seat?.number}
      />
      <div
        className={cn(
          'col-12 py-3 fw-600 d-flex align-items-center justify-content-center' , orderingPortraitOrientation ? 'fs_18' : 'fs_20'
        )}
      >
        {LABEL().ACTIVATE_GIFT_CARD}
      </div>
      {<ServerInstructions orderingPortraitOrientation = {orderingPortraitOrientation}/>}
      <div className={cn('px-3')} style={{ height: '54%' }}>
        <div
          className={cn('col-12 px-0' , orderingPortraitOrientation ? '' : 'h-100')}
          style={{
            border: serverAppTheme?.gameCard_table_border,
            borderRadius: '4px',
            overflow: !disPlayBtn && "scroll"
          }}
        >
            <>
              {' '}
              <table className={cn('w-100', style.table , orderingPortraitOrientation ? style.verticalmodetable : 'h-100')}>
                <thead className={style.headerFixed}>
                  <tr
                    style={{
                      borderBottom: serverAppTheme?.gameCard_table_border,
                      padding: '0 28px',
                    }}
                  >
                    <th
                      className={cn(
                        'col-4 text-left py-1 px-0 fw-normal' ,orderingPortraitOrientation ?'fs_12' :'fs_14'
                      )}
                    >
                      {LABEL().CARDNAME}
                    </th>
                    <th className={cn('col-2 text-left py-1 fw-normal' , orderingPortraitOrientation ? 'pl-0 fs_12 pr-1' : 'fs_14')}>
                      {LABEL().AMOUNT}
                    </th>
                    <th className={cn('col-4 text-left py-1 fw-normal',orderingPortraitOrientation ?'fs_12' :'fs_14')}>
                      {LABEL().CARDNUMBER}
                    </th>
                    <th
                      className={cn(
                        'col-2 text-center py-1 fw-normal',orderingPortraitOrientation ?'fs_12' :'fs_14 pl-3'
                      )}
                    >
                      {LABEL().SELECT}
                    </th>
                  </tr>
                </thead>
                <tbody className={cn('h-89')}>
                  {getActivateGiftCards()?.map((item, index) => {
                    return (
                      <tr
                        style={{
                          borderBottom: serverAppTheme?.gameCard_table_border,
                          color: serverAppTheme?.primary_text,
                          padding: '0 28px',
                        }}
                        key={1}
                      >
                        <td
                          className={cn('col-4 px-0 py-2' , orderingPortraitOrientation ? 'fs_12 fw-500' : 'fw-normal fs_14')}
                          style={{ padding: '0 5px', overflow: 'scroll' }}
                        >
                          <div>
                            <div>{item?.name}</div>
                            <div className="pl-2">
                              {' '}
                            </div>
                          </div>
                        </td>
                        <td
                          className={cn('col-2 px-0 py-2',orderingPortraitOrientation ? 'fs_12 fw-500' : 'fw-normal fs_14')}
                          style={{ padding: '0 5px' }}
                        >
                          {LABEL().CURRENCY_SYMBOL}
                          {item?.amount.toFixed(2)}
                        </td>
                        <td
                          className={cn('col-4  py-2', orderingPortraitOrientation ? 'fs_12 fw-500 pl-3 pr-0' : 'fw-normal fs_14 px-0')}
                          style={{ padding: '0 5px' }}
                        >
                          {item?.status === 5 && item?.number}
                        </td>
                        <td
                          className={cn(
                            'col-2 px-0 py-2 d-flex justify-content-center align-items-center'
                          )}
                        >
                          <div
                            className={cn(
                              'w-100 h-100 d-flex align-items-center justify-content-center pl-3'
                            )}
                          >
                            {item?.status === 5 ? (
                              <>
                                {item?.void ?
                                  <div>
                                    <GiftCardExclamation />
                                  </div> :
                                  <div
                                    className="d-flex justify-content-center align-items-center"
                                  >
                                    <SuccessIcon />
                                  </div>}
                              </>
                            ) : (
                                <button
                                  style={{
                                    height: orderingPortraitOrientation ? '24px' : '7vh',
                                    backgroundColor: getSwipeBtnDisable()
                                      ? serverAppTheme.primary_btn_disable
                                      : serverAppTheme?.secondaryBtn,
                                    color: getSwipeBtnDisable()
                                      ? serverAppTheme?.btn_font_color_disabled
                                      : serverAppTheme?.btn_font_color,
                                  }}
                                  type="submit"
                                  disabled={getSwipeBtnDisable()}
                                  className="col-12 px-0 border-0 rounded btn-ripple fs_14 fw-normal d-flex justify-content-center align-items-center"
                                  onClick={e => {
                                    e.preventDefault();
                                    setOrderData(item)
                                    if (balanceEnabled) window.sessionStorage.removeItem('giftCard_type');
                                    OnProcess(item);
                                  }}
                                >
                                  {LABEL().GAMECARDSWIPE}
                                </button>
                            )}
                          </div>
                        </td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          {/* )} */}
        </div>
        {/* {!tab && ( */}
        {disPlayBtn &&
          <div
            style={{ bottom: orderingPortraitOrientation ? '1.875rem' :'1rem', left: 0 }}
            className={cn("col-12 px-3  d-flex align-items-end justify-content-center h-12 position-absolute")}
          >
            <TouchableButton
              type="cancel"
              style={{
                width: orderingPortraitOrientation ? '50%' : '35%',
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                border: serverAppTheme?.cancleBtn_Border,
                color: serverAppTheme?.cancleBtn_font,
                marginRight: "8px"
              }}
              className={cn(
                'px-0  fw-600 btn-ripple rounded d-flex justify-content-center align-items-center py-2' , orderingPortraitOrientation ?'btn68' : 'btn44'
              )}
              onClick={() => {
                handlebacKToCheckListing();
              }}
              rippleEffect={true}
            >
              {LABEL().GIFT_CARD_BACK_TO_CHECK}
            </TouchableButton>
            <TouchableButton
              type="submit"
              style={{
                width: orderingPortraitOrientation ? '48%' : '35%',
                backgroundColor:
                  getActivateGiftCards().length == 0
                    ? serverAppTheme?.primary_btn_disable
                    : serverAppTheme?.secondaryBtn,
                color:
                  getActivateGiftCards().length == 0
                    ? serverAppTheme?.btn_font_color_disabled
                    : serverAppTheme?.btn_font_color,
                opacity: 1,
              }}
              className={cn(
                'px-0  fw-600 btn-ripple border-0 rounded d-flex justify-content-center align-items-center',orderingPortraitOrientation ?'btn68 ' : 'btn44'
              )}
              disabled={getActivateGiftCards().length == 0}
              onClick={() => sendAndPay()}
            >
              {LABEL().GIFT_CARD_PAYMENT}
            </TouchableButton>
          </div>}
        {!disPlayBtn && (
          <div
            style={{ bottom: '1rem', left: 0 }}
            className="col-12 py-0 px-0 d-flex align-items-end justify-content-center h-12 position-absolute"
          >
            <TouchableButton
              type="submit"
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              className={cn(
                'col-4 px-0 btn44 fw-600 btn-ripple border-0 rounded d-flex justify-content-center align-items-center'
              )}
              onClick={() => handlebacKToCheckListing()}
            >
              {LABEL().OS_CLOSE}
            </TouchableButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftCardactivation;
